import React from "react";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { useDispatch } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { createWorkspace } from "slices/systemAdmin/actions/systemAdmin";

const WorkspacesCreate = () => {
  const dispatch = useDispatch();
  const createNewWorkspace = (workspaceName) => {
    dispatch(createWorkspace(workspaceName));
  };

  return (
    <div
      className="system_admin__create__workspace"
      data-testid="workspaces-create"
    >
      <span>Create Workspace</span>
      <Button
        onClick={() => {
          dispatch(
            showModal(modalTypes.TEXT_FIELD_MODAL, {
              title: "Create Workspace",
              placeholderText: "Workspace Name",
              buttonText: "Create Workspace",
              errorMessage:
                "Workspace name must only contain alphanumeric characters and following special characters: ()+-.",
              onOk: createNewWorkspace,
            })
          );
        }}
        variant={buttonVariants.primary}
        content={<span>Create Workspace</span>}
      />
    </div>
  );
};

export default WorkspacesCreate;
